import { Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function SuccessResponse({ title, message, handleClick, ButtonName }) {
  return (
    <Grid className="container ">
      <Grid item xs={12} className="centered-div gutterBottom ">
        <IconButton className="mb-2">
          <CheckCircleIcon fontSize="large" color="primary" />
        </IconButton>
        <Typography className="mb-2" variant="h6" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
        <Typography variant="body1" className="mb-2">
          {message}
        </Typography>
        <Button
          onClick={() => handleClick()}
          variant="contained"
          style={{ width: "60%", marginTop: "1rem" }}
        >
          {ButtonName}
        </Button>
      </Grid>
    </Grid>
  );
}

export default SuccessResponse;
